import { api } from './client.js';

export function fetchMySaju({ signal } = {}) {
    return api('/me/saju', { signal });
}

/** 사주 · 별자리 정보 지우기(DEV-07z4 · D102) */
export function deleteMySaju() {
    return api('/me/saju', { method: 'DELETE' });
}

export function updateMySaju(payload) {
    return api('/me/saju', { method: 'PATCH', body: payload });
}

export function fetchNotifications({ signal } = {}) {
    return api('/me/notifications', { signal });
}

export function updateNotification(kind, enabled) {
    return api('/me/notifications', { method: 'PATCH', body: { kind, enabled } });
}

/** 나 탭 설정(알림 말고): { sajuAside } — 이모가 사주 얘기 곁들이기 (명세 v1.3 12장 C-17) */
/** 나 탭 호칭 고치기(DEV-07z3 · D101). 서버가 이름만 뽑아 저장하고 단골 정보를 돌려줌 */
export function updateDisplayName(displayName) {
    return api('/me/display-name', { method: 'PATCH', body: { displayName } });
}

export function fetchPrefs({ signal } = {}) {
    return api('/me/prefs', { signal });
}

export function updatePrefs(changes) {
    return api('/me/prefs', { method: 'PATCH', body: changes });
}

/** 다음 날 알림 물음에 답했음(다시 묻지 않음, 시안 05 결정 19) */
export function answerPushAsk() {
    return api('/me/push-asked', { method: 'POST', body: {} });
}

/** 이모 수첩. scope=room|chat, member=멤버 key (시안 04 D2c · D2e) */
export function fetchMemories({ signal, scope = null, member = null } = {}) {
    const query = new URLSearchParams();
    if (scope) {
        query.set('scope', scope);
    }
    if (member) {
        query.set('member', member);
    }
    const suffix = query.size ? `?${query}` : '';
    return api(`/me/memories${suffix}`, { signal });
}

export function clearMemories() {
    return api('/me/memories', { method: 'DELETE' });
}

/** 이모 수첩 한 줄 고치기 (명세 v1.3 C-10) */
export function editMemory(memoriesId, text) {
    return api(`/me/memories/${memoriesId}`, { method: 'PATCH', body: { text } });
}

/** 이모 수첩 한 줄 지우기 */
export function deleteMemory(memoriesId) {
    return api(`/me/memories/${memoriesId}`, { method: 'DELETE' });
}

/** 나 탭 계정 줄 · 탈퇴 화면: { provider, email, recentCrisis } (시안 06 M1 · M3) */
export function fetchAccount({ signal } = {}) {
    return api('/me/account', { signal });
}

/** 회원 탈퇴 (시안 06 M3). reason: rarely · not_expected · too_many_alerts · record_burden · other 또는 null */
export function deleteAccount(reason = null) {
    return api('/me', { method: 'DELETE', body: { reason } });
}

/**
 * 단골이 이모 수첩에 직접 적기 (C-31 · D75). 민감하면 409 NOTE_SENSITIVE(confirmSensitive 로 다시), 위기면 409 CRISIS_NOTE
 * @param {{ text: string, scope: string, kind?: string|null, dueOn?: string|null, entry: string, confirmSensitive?: boolean,
 *   originMessageId?: number, originSurface?: 'room'|'chat', originMemberKey?: string }} note
 */
export function addNote(note) {
    return api('/notebook', { method: 'POST', body: note });
}

/** 단골이 적은 줄 고치기: 문장 · 누가 알게 할지 · 분류 · 일정 날짜 */
export function editNote(memoriesId, { text, scope, kind = null, dueOn = null }) {
    return api(`/notebook/${memoriesId}`, { method: 'PATCH', body: { text, scope, kind, dueOn } });
}
